import _get from 'lodash/get';

import * as toast from './toast';
import type { ToastOptions } from 'interface/common';

const GENERIC_ERROR = 'Oops! Something went wrong';
const ERROR_MESSAGES_TO_IGNORE = new Set(['Request aborted']);

/**
 * Handles API failures and shows a readable toast message.
 *
 * @param event - Error payload returned by API calls.
 * @param options - Optional toast overrides.
 */
export function handleError(event: object, options: ToastOptions = {}): void {
  const message = _get(event, 'response.data.error.message') ?? _get(event, 'response.data.message', GENERIC_ERROR);

  if (ERROR_MESSAGES_TO_IGNORE.has(message)) {
    return;
  }

  toast.error({
    title: options.title || 'Error',
    message: options.message || message,
    className: options.className || '',
  });
}
